// extracted by mini-css-extract-plugin
module.exports = {"cuvetteLid":"style_cuvetteLid__11vst"};